@use '@/sass/variables';

.tooltip-bubble {
  background-color: variables.$near-black;
  color: variables.$white;
  line-height: variables.$line-height-copy;
  max-width: variables.$max-width-5;
  display: inline-block;
  border-radius: variables.$border-radius-1;
  padding: variables.$spacing-extra-small variables.$spacing-small;
  font-size: variables.$font-size-6;
  word-wrap: break-word;

  [data-arrow-align] {
    width: 0;
    height: 0;
    position: absolute;
    z-index: 20;
    pointer-events: none;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
  }

  // `left` is set inline, from the trigger's centre rather than the bubble's edge.
  [data-arrow-align='top'] {
    top: -11px;
    border-bottom: 12px solid variables.$near-black;
  }
  [data-arrow-align='bottom'] {
    bottom: -11px;
    border-top: 12px solid variables.$near-black;
  }
}
